import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { BaseLink } from "../../../../models/base-link";
import { CostRegistrationsControllerService } from "../../../../services/crossed-tables/cost-registrations-controller.service";
import { DeterminantRegistrationsControllerService } from "../../../../services/crossed-tables/determinant-registrations-controller.service";
import { DocumentRegistrationsControllerService } from "../../../../services/crossed-tables/document-registrations-controller.service";
import { FieldPropertiesControllerService } from "../../../../services/crossed-tables/field-properties-controller.service";
import { FormFieldRegistrationsControllerService } from "../../../../services/crossed-tables/formfield-registrations-controller.service";
import { FormFieldDeterminantControllerService } from "../../../../services/crossed-tables/formfield-determinant-controller.service";
import { InstitutionRegistrationsControllerService } from "../../../../services/crossed-tables/institution-registrations-controller.service";
import { RoleRegistrationsControllerService } from "../../../../services/crossed-tables/role-registrations-controller.service";
import { ServiceLocationRegistrationsControllerService } from "../../../../services/crossed-tables/service-location-registration-controller.service";
import { InstitutionControllerService } from "../../../../services/institution-controller/institution-controller.service";

@Component({
  selector: "app-cross-tables-base",
  templateUrl: "./cross-tables-base.component.html",
  styleUrls: ["./cross-tables-base.component.scss"],
  providers: [
      CostRegistrationsControllerService,
      DocumentRegistrationsControllerService,
      DeterminantRegistrationsControllerService,
      FormFieldRegistrationsControllerService,
      FormFieldDeterminantControllerService,
      InstitutionControllerService,
      InstitutionRegistrationsControllerService,
      RoleRegistrationsControllerService,
      FieldPropertiesControllerService,
      ServiceLocationRegistrationsControllerService,
  ],
})
export class CrossTablesBaseComponent implements OnInit {

    // items list
    public items: any[];
    public serviceId: string;
    public filterValue: string;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private costRegistrationsControllerService: CostRegistrationsControllerService,
                private documentRegistrationsController: DocumentRegistrationsControllerService,
                private determinantRegistrationsControllerService: DeterminantRegistrationsControllerService,
                private formFieldRegistrationsControllerService: FormFieldRegistrationsControllerService,
                private formFieldDeterminantControllerService: FormFieldDeterminantControllerService,
                private institutionControllerService: InstitutionControllerService,
                private institutionRegistrationsControllerService: InstitutionRegistrationsControllerService,
                private roleRegistrationsControllerService: RoleRegistrationsControllerService,
                private fieldPropertiesControllerService: FieldPropertiesControllerService,
                private serviceLocationRegistrationsControllerService: ServiceLocationRegistrationsControllerService,
    ) {

    }

    public ngOnInit() {

        this.route.params.subscribe((params) => {
            this.serviceId = params.serviceId;
        });
        this.getItemsList();
    }

    private getItemsList() {

        this.items = [
            [
                new BaseLink("nav.annexes.tables.formfields_regis", `/services/${this.serviceId}/formfieldsreg`, this.formFieldRegistrationsControllerService.getFormFieldRegistrationsRelationsList(this.serviceId)),
                new BaseLink("nav.annexes.tables.docs_regis", `/services/${this.serviceId}/docsreg`, this.documentRegistrationsController.getDocumentRequestRegistrationsList(this.serviceId)),
                new BaseLink("nav.annexes.tables.costs_regis", `/services/${this.serviceId}/costreg`, this.costRegistrationsControllerService.getCostRegistrationsRelationsList(this.serviceId)),
            ],
            [
                new BaseLink("nav.annexes.tables.dets_regis", `/services/${this.serviceId}/detreg`, this.determinantRegistrationsControllerService.getDeterminantRegistrationsRelationsList(this.serviceId)),
                new BaseLink("nav.annexes.tables.formfields_det", `/services/${this.serviceId}/formfieldsdet`, this.formFieldDeterminantControllerService.getFormFieldDeterminantRelationsList(this.serviceId)),
            ],
            [
                new BaseLink("nav.annexes.tables.roles_regis", `/services/${this.serviceId}/rolereg`, this.roleRegistrationsControllerService.getroleRegistrationsRelationsList(this.serviceId)),
            ],
            [
                new BaseLink("nav.annexes.tables.fields_props", `/services/${this.serviceId}/fieldsProps`, this.fieldPropertiesControllerService.getFieldPropertiesList(this.serviceId)),
            ],
            [
                new BaseLink("nav.annexes.tables.inst_regis", `/services/${this.serviceId}/instreg`),
                new BaseLink("nav.annexes.tables.service_locations_regis", `/services/${this.serviceId}/servicelocreg`, this.serviceLocationRegistrationsControllerService.getServicelocationsRegistrationsRelationsList(this.serviceId)),
            ],
        ];

        // for institutions/registrations
        this.setInstitutionsItemLabel(this.items[4][0]);
    }

    public setInstitutionsItemLabel(item: BaseLink): void {
        this.institutionControllerService.getInstitutions().subscribe(
            (data) => {
                const institutions = data;
                if (institutions && institutions.length > 0) {
                    this.institutionRegistrationsControllerService.getInstitutionRegistrationsRelationsList(this.serviceId, institutions).subscribe(
                        (cb) => {
                            item.setLabel(cb.length.toString());
                        },
                    );
                }
            },
        );
    }

    public onFilter(value): void {
        this.filterValue = value;
    }
}
